module.exports = __webpack_public_path__ + "static/media/adjuge-hu.c84b9b81.png";